export default [
    {
        path: '/static/product/select-add/:appId',
        name: 'product-select-add',
        component: () => import('views/modules/product/select/add'),
        meta: {
            parent: '/product/select',
            icon: 'el-icon-document',
            title: '添加筛选组',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
    },
    /* {
        path: '/static/product/edit/:appId',
        name: 'product-edit',
        component: () => import('views/modules/product/edit'),
        meta: {
            parent: '/product/list',
            icon: 'el-icon-document',
            title: '添加产品',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
    }, */
    {
        path: '/static/product/draft/:appId',
        name: 'product-draft',
        component: () => import('views/modules/product/draft'),
        meta: {
            parent: '/product/list',
            icon: 'el-icon-document',
            title: '草稿箱',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
    },
    {
        path: '/static/product/template-edit/:appId',
        name: 'product-template-edit',
        component: () => import('views/modules/product/template-edit'),
        meta: {
            parent: '/product/template-list',
            icon: 'el-icon-document',
            title: '新增属性模板',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
    },    
];
